import { useCallback, useContext } from 'react';
import elementSettings from 'src/js/modules/element-settings';
import combineBatches from 'src/js/modules/element-settings/helpers/combine-batches';
import getAutoPaddingBreakpointBatch from '../helpers/get-auto-padding-breakpoint-batch';

const { Context: ElementSettingsContext } = elementSettings;

const useAutoPaddingSync = () => {
  const { state } = useContext(ElementSettingsContext);

  const getAutoPaddingBatch = useCallback(
    (breakpointBasedBatch, { elementIds } = {}) => {
      const nextState = combineBatches([state, breakpointBasedBatch]);

      return getAutoPaddingBreakpointBatch({ state: nextState, elementIds });
    },
    [state]
  );

  return { getAutoPaddingBatch };
};

export default useAutoPaddingSync;
